import { render, staticRenderFns } from "./DistrictInfoHeader.vue?vue&type=template&id=a04dfba2&scoped=true&"
import script from "./DistrictInfoHeader.vue?vue&type=script&lang=js&"
export * from "./DistrictInfoHeader.vue?vue&type=script&lang=js&"
import style0 from "./DistrictInfoHeader.vue?vue&type=style&index=0&id=a04dfba2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04dfba2",
  null
  
)

export default component.exports